import * as PIXI from 'pixi.js';
import { GameAssets } from 'src/shared/util/GameAssets';

export class BonusCounter extends PIXI.Container {
    private bonusCounter: PIXI.Text;
    private sprite: PIXI.Sprite;
    private freespins: number = 0;

    constructor() {
        super(); // Call the PIXI.Container constructor

        this.sprite = new PIXI.Sprite(GameAssets.textures.gameAtlas.textures["fsCounter.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.scale.set(0.5);
        this.sprite.position.set(0, 0);
        // Create gradient fill
        const fill = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0 },  // Start at top
            end: { x: 0, y: 1 },    // End at bottom
            colorStops: [
                { offset: 0, color: 0xffffda },
                { offset: 1, color: 0xe7ac3f }
            ],
            // Use normalized coordinate system where (0,0) is the top-left and (1,1) is the bottom-right of the shape
            textureSpace: 'local'
        });
        // Initialize the PIXI.Text object
        this.bonusCounter = new PIXI.Text({
            text: '7',
            style: {
                fontSize: 120,
                fontFamily: "TextFont",
                align: 'center',
                fill: { fill },
                fontWeight: "bold",
                stroke: {
                    color: 0x000000,
                    width: 4,
                }
            }
        });
        this.bonusCounter.anchor.set(0.5);

        // Add the bonusCounter as a child of this container
        this.addChild(this.sprite);
        this.addChild(this.bonusCounter);
    }

    // Method to set the initial amount of freespins
    public setFreespins(amount: number): void {
        this.freespins = amount;
        this.updateText();
    }

    // Method to decrement the freespins amount and update the text
    public decrement(): void {
        if (this.freespins > 0) {
            this.freespins -= 1;
            this.updateText();
        }
    }

    // Method to update the text of the bonusCounter
    private updateText(): void {
        const spinText = this.freespins <= 1 ? 'FREE SPIN' : 'FREE SPINS';
        // this.bonusCounter.text = `${this.freespins}\n${spinText}`;
        this.bonusCounter.text = `${this.freespins}`;
    }

}
